var map = {
	"./add-bordered.svg": "4KG6",
	"./agenda.svg": "weoB",
	"./alarm.svg": "mqv/",
	"./at.svg": "rxQG",
	"./back-thick.svg": "qZsf",
	"./back.svg": "VSxP",
	"./bell-outlined.svg": "5sAV",
	"./bell.svg": "pfdK",
	"./boy-thinking.svg": "3qvx",
	"./cactus.svg": "g6Ru",
	"./calendar-icon.svg": "EPO9",
	"./calendar.svg": "zxfl",
	"./call.svg": "pjRO",
	"./camera-outlined.svg": "6I8r",
	"./camera.svg": "/LBv",
	"./card.svg": "oCJh",
	"./cardpaper-box.svg": "7YlG",
	"./cat.svg": "RDIJ",
	"./chat-bubble.svg": "hRzH",
	"./check.svg": "5aLq",
	"./checked.svg": "qfN+",
	"./circle-spinner.svg": "15aA",
	"./circle.svg": "+g7B",
	"./clock.svg": "4/yx",
	"./close.svg": "mq5u",
	"./cloud.svg": "8BXe",
	"./clouds.svg": "qdSx",
	"./collective-rate.svg": "xR+D",
	"./copy.svg": "rjgy",
	"./cross-red-circle.svg": "YCfh",
	"./cross.svg": "+G+z",
	"./crying.svg": "jyjU",
	"./curly-brackets.svg": "ZEwt",
	"./danger.svg": "f5f8",
	"./document-search.svg": "b7zB",
	"./download.svg": "QwFe",
	"./drag-handle.svg": "UWne",
	"./earth-virus.svg": "cceA",
	"./edit.svg": "/LjC",
	"./empty-box.svg": "wuAZ",
	"./envelope.svg": "qbyd",
	"./folder.svg": "UHZA",
	"./gallery.svg": "r2/a",
	"./gear.svg": "i2Bk",
	"./giftbox.svg": "uvER",
	"./girl.svg": "SZkf",
	"./half-circle.svg": "ryA8",
	"./happy.svg": "tdzW",
	"./heart-eyes.svg": "dRWT",
	"./heart.svg": "QVSs",
	"./history.svg": "VPAs",
	"./home-outlined.svg": "uwBJ",
	"./home.svg": "vFnY",
	"./id-card.svg": "5Kvy",
	"./iphone-wireframe.svg": "SdGg",
	"./key-kawaii.svg": "G4AY",
	"./key-outlined.svg": "m4U/",
	"./key.svg": "1B5A",
	"./left-arrow.svg": "N2cq",
	"./location-pin.svg": "Ng/d",
	"./lock.svg": "oLT6",
	"./logout.svg": "V/i2",
	"./magnifying-glass-thin.svg": "y0Ls",
	"./magnifying-glass.svg": "sLHM",
	"./mail.svg": "+zzn",
	"./map.svg": "026T",
	"./menu.svg": "aw7U",
	"./minus.svg": "I4UB",
	"./newspaper-icon.svg": "INxw",
	"./newspaper.svg": "tBJo",
	"./objects-magnifier.svg": "0IOK",
	"./padlock.svg": "KVdt",
	"./paint-brush.svg": "FdZO",
	"./paper-plane.svg": "81S5",
	"./party.svg": "573o",
	"./pencil-illustration.svg": "2o0X",
	"./pencil-outlined.svg": "pGuV",
	"./pencil.svg": "Jid5",
	"./people.svg": "6Eq/",
	"./photo.svg": "feCs",
	"./photos.svg": "AJgP",
	"./pin.svg": "4Izz",
	"./plus-outlined.svg": "KWlp",
	"./plus.svg": "XgQ+",
	"./qr-code.svg": "o15h",
	"./question-mark-circle.svg": "aeUi",
	"./question-mark.svg": "hgGa",
	"./question.svg": "XwX0",
	"./rain.svg": "Ve2j",
	"./sad.svg": "KQOH",
	"./satellite.svg": "Qq7i",
	"./semicircular-up-arrow.svg": "Kgaf",
	"./separator-long.svg": "Gkoy",
	"./separator.svg": "Ay+d",
	"./shield.svg": "AKC5",
	"./shopping-bag.svg": "aaqm",
	"./smartphone-lookup.svg": "+0q7",
	"./smile.svg": "9hWo",
	"./snow.svg": "Lgb5",
	"./speaker.svg": "0mMS",
	"./splash.svg": "1V3v",
	"./star.svg": "Hpq9",
	"./store-icon.svg": "g+i+",
	"./store.svg": "iXVx",
	"./sun-cloud.svg": "iYod",
	"./sun.svg": "U8Nl",
	"./tag.svg": "evpZ",
	"./text-typing.svg": "dSmS",
	"./thermostat.svg": "WgRA",
	"./thunder.svg": "hCZp",
	"./thunderstorm.svg": "awxp",
	"./ticket.svg": "GAy8",
	"./trash.svg": "dSYB",
	"./user-outlined.svg": "NRdu",
	"./user.svg": "4xPT",
	"./wind-blowing-leaves.svg": "FveI",
	"./wind.svg": "aLgU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UKcq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\.svg$
// module id = UKcq
// module chunks = 1